import { Injectable, inject } from '@angular/core';
import {
  NotificationListComponent,
  NotificationService,
} from '@appkit4/angular-components/notification';
import { TranslateService } from '@ngx-translate/core';
import { NotificationTriggerState } from '@shared/abstraction/notification/notification-trigger-state';
import { CrudOperation } from '@shared/enums/crud-operation';
import { NotificationStatus } from '@shared/enums/notification-status';

@Injectable({
  providedIn: 'root',
})
export class AppNotificationService {
  private translateService = inject(TranslateService);
  private notificationService = inject(NotificationService);

  notificationListApp?: NotificationListComponent;

  currentNotificationState: NotificationTriggerState = {
    id: 'global-notification-message',
    status: NotificationStatus.DEFAULT,
    showClose: true,
    duration: 3000,
  };

  setGlobalNotification(notificationListApp: NotificationListComponent): void {
    this.notificationListApp = notificationListApp;
  }

  crudNotify(
    operation: CrudOperation,
    entityName: string,
    success = true,
    parseDescriptionToLower = true
  ): void {
    const title = this.translateService.instant(
      success
        ? `notifications.${operation}TitleSuccess`
        : `notifications.${operation}TitleFail`,
      { entityName }
    );
    if (parseDescriptionToLower) {
      entityName = entityName.toLowerCase();
    }
    const desc = this.translateService.instant(
      success
        ? `notifications.${operation}DescriptionSuccess`
        : `notifications.${operation}DescriptionFail`,
      { entityName }
    );

    this.notificationService.show(title, desc, '', '', {
      duration: 3000,
      id: 'global-notification-message',
      clickToClose: false,
      showClose: true,
      icon: success ? 'icon-success-fill' : 'icon-error-fill',
    });
  }

  notify(
    title: string,
    description: string,
    status: NotificationStatus,
    params: JSONObject = {}
  ): void {
    let translatedTitle: string = this.translateService.instant(title, params);

    translatedTitle =
      translatedTitle.charAt(0).toUpperCase() +
      translatedTitle.slice(1).toLowerCase();

    let translatedDescription: string = this.translateService.instant(
      description,
      params
    );

    translatedDescription =
      translatedDescription.charAt(0).toUpperCase() +
      translatedDescription.slice(1).toLowerCase();

    this.currentNotificationState.status = status;

    this.notificationService.show(
      translatedTitle,
      translatedDescription,
      '',
      '',
      {
        ...this.currentNotificationState,
        icon: `icon-${status.toString()}-fill`,
      }
    );
  }

  /** Pre-translated title/description (e.g. guard toasts). */
  showTranslatedToast(
    title: string,
    description: string,
    icon = 'icon-error-fill',
    duration = 6000
  ): void {
    this.notificationService.show(title, description, '', '', {
      duration,
      id: 'global-notification-message',
      showClose: true,
      clickToClose: false,
      icon,
    });
  }
}
